import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import styled from "styled-components";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { makeStyles } from "@mui/styles";
import ImageList from "@mui/material/ImageList";
import Tooltip from "@mui/material/Tooltip";
import Edit from "@mui/icons-material/Edit";
import Chip from "@mui/material/Chip";
import { ActionContext } from "context/ActionContext";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import UserService from "services/UserService";
import { putAction, getAction } from "services/ConfigServices";
import { action as actionVar } from "variables/action";
import {
  categoryData,
  subCategoryData,
  statusData,
  criticityData,
} from "variables/lists/action";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import {
  AutocompleteInput,
  CustomSelect,
  CustomSwitch,
  DateInput,
  FloatInput,
  IntInput,
  LocalizationAutocomplete,
  TextInput,
} from "components/Input/Index.js";
import EditButton from "components/CustomButtons/EditButton";

const useStyles = makeStyles((theme) => ({
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

const GroupCell = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export default function GeneralEdit({
  apiData,
  params,
  closeModal,
  groupParent,
}) {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanupdate = permis.includes("actionplan_update");
  const appContext = useContext(ActionContext);
  const { action, setAction } = appContext;

  const groupInfoContext = useContext(AdvancedSearchContext);
  const { groupInfoListById } = groupInfoContext;

  const [newGeneral, setNewGeneral] = useState({});
  const [groupsParent, setGroupsParent] = useState(groupParent[0]);
  const [groups, setGroups] = useState();
  const [editGroups, setEditGroups] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewGeneral((prevState) => ({
      ...prevState,
      [params]: { ...prevState.general, [name]: value },
    }));
  };

  const handleStatusChange = (e) => {
    const { name, value } = e.target;
    setNewGeneral((prevState) => ({
      ...prevState,
      [params]: {
        ...prevState.general,
        [name]: value,
        lastupdate: new Date().toISOString().slice(0, 10),
      },
    }));
  };

  useEffect(() => {
    setNewGeneral(action?.parameters || {});
    setGroups(action?.parameters?.[params]?.groups || []);
  }, [action]);

  const urlPlanAction = getAction(action.id);

  let url = putAction(action.id);

  const handleSubmit = async (event) => {
    createActionGeneral(event);
  };

  const createActionGeneral = async (event) => {
    const groupsIsAnArray = Array.isArray(groups);
    if (groupsIsAnArray) {
      axios
        .put(
          url,
          {
            ...newGeneral,
            general: { ...newGeneral.general, groups },
          },
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
              'Content-Type': "application/json; charset=utf-8",
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            setAction((prevState) => ({
              ...prevState,
              parameters: {
                ...newGeneral,
                general: { ...newGeneral.general, groups },
              },
            }));
            setNotification("success", "Paramètres généraux modifiée");
            getActionData();
          } else setNotification("error", "Une erreur est survenue");
        })
        .catch((error) => {
          setNotification("error", "Une erreur est survenue");
          //setLoading(false);
        });
    } else {
      axios
        .put(
          url,
          {
            ...newGeneral,
            general: {
              ...newGeneral.general,
              groups: [groups],
            },
          },
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
              'Content-Type': "application/json; charset=utf-8",
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            setNotification("success", "Paramètres généraux modifiée");
            getActionData();
          } else setNotification("error", "Une erreur est survenue");
        })
        .catch((error) => {
          setNotification("error", "Une erreur est survenue");
          //setLoading(false);
        });
    }
  };

  const getActionData = () => {
    axios
      .get(urlPlanAction, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((response) => {
        setAction(response.data || []);
        setNewGeneral(response.data.parameters || {});
        setGroups(response.data.parameters?.[params]?.groups || []);
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const showEntitesTree = () => {
    setEditGroups((prevCheck) => !prevCheck);
  };

  const classes = useStyles();

  return (
    <>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12} xl={12}>
          <div style={{ marginLeft: "25px", marginTop: "1rem" }}>
            Périmètre :
            <GroupCell>
              {groups?.map((groupid) => {
                return <Chip label={groupInfoListById[groupid]} key={groupid} />;
              })}
            </GroupCell>
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextInput
            inputTitle={actionVar[params].name}
            textInput={newGeneral?.[params]?.name}
            handleTextInputChange={handleChange}
            name="name"
            disabled={!actionplanupdate}
          />

          <TextInput
            inputTitle={actionVar[params].type}
            textInput={newGeneral?.[params]?.type}
            handleTextInputChange={handleChange}
            name="type"
            disabled={!actionplanupdate}
          />
          <TextInput
            inputTitle={actionVar[params].category}
            textInput={
              categoryData.find(
                (cat) => cat.id == newGeneral?.[params]?.category
              )?.name || ""
            }
            handleTextInputChange={handleChange}
            name="category"
            disabled={true}
          />
          <CustomSelect
            inputTitle={actionVar[params].status}
            selectValue={newGeneral?.[params]?.["status"] || ""}
            handleSelectValueChange={handleStatusChange}
            data={statusData}
            name="status"
            disabled={!actionplanupdate}
          />
          <DateInput
            inputTitle={actionVar[params].wantedstartdate}
            dateInput={newGeneral?.[params]?.wantedstartdate}
            handleDateInputChange={handleChange}
            name="wantedstartdate"
            disabled={!actionplanupdate}
          />
          <DateInput
            inputTitle={actionVar[params].realstartdate}
            dateInput={newGeneral?.[params]?.realstartdate}
            handleDateInputChange={handleChange}
            name="realstartdate"
            disabled={!actionplanupdate}
          />
          <TextInput
            inputTitle={actionVar[params].orgincharge}
            textInput={newGeneral?.[params]?.orgincharge}
            handleTextInputChange={handleChange}
            name="orgincharge"
            disabled={!actionplanupdate}
          />
          <TextInput
            inputTitle={actionVar[params].description}
            textInput={newGeneral?.[params]?.description}
            handleTextInputChange={handleChange}
            name="description"
            multiline
            rows={4}
            disabled={!actionplanupdate}
            style={{ heigh: "100px" }}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextInput
            inputTitle={actionVar[params].code}
            textInput={newGeneral?.[params]?.code}
            handleTextInputChange={handleChange}
            name="code"
            disabled={!actionplanupdate}
          />
          <CustomSelect
            inputTitle={actionVar[params].criticity}
            selectValue={newGeneral?.[params]?.["criticity"] || ""}
            handleSelectValueChange={handleChange}
            data={criticityData}
            name="criticity"
            disabled={!actionplanupdate}
          />
          <TextInput
            inputTitle={actionVar[params].subcategory}
            textInput={newGeneral?.[params]?.subcategory}
            handleTextInputChange={handleChange}
            name="subcategory"
            disabled={!actionplanupdate}
          />
          <DateInput
            inputTitle={actionVar[params].lastupdate}
            dateInput={newGeneral?.[params]?.lastupdate}
            handleDateInputChange={handleChange}
            name="lastupdate"
            disabled={!actionplanupdate}
          />

          <DateInput
            inputTitle={actionVar[params].wantedenddate}
            dateInput={newGeneral?.[params]?.wantedenddate}
            handleDateInputChange={handleChange}
            name="wantedenddate"
            disabled={!actionplanupdate}
          />

          <DateInput
            inputTitle={actionVar[params].realenddate}
            dateInput={newGeneral?.[params]?.realenddate}
            handleDateInputChange={handleChange}
            name="realenddate"
            disabled={!actionplanupdate}
          />
          <TextInput
            inputTitle={actionVar[params].personincharge}
            textInput={newGeneral?.[params]?.personincharge}
            handleTextInputChange={handleChange}
            name="personincharge"
            disabled={!actionplanupdate}
          />
        </GridItem>
      </GridContainer>
      {actionplanupdate && (
        <GridContainer>
          <GridItem
            xs={12}
            sm={12}
            md={7}
            lg={7}
            style={{ marginLeft: "8px", marginTop: "12px" }}
          >
            <EditButton handleSubmit={handleSubmit}>Modifier</EditButton>
          </GridItem>
        </GridContainer>
      )}
    </>
  );
}
